module.exports = __webpack_public_path__ + "assets/f070785d3e21f349865c51ab43fd36bb.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/345XAddMulti.mp3
 ** module id = 236
 ** module chunks = 0
 **/